import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useCallback, useEffect, useState } from 'react';
import { getAccessMgmtEndPoint, updateAccessReqEndPoint } from '../utils';
import axios from 'axios';
import notify from '../../../services/toasterService';
import { ReactComponent as Delete } from '../../../icons/delete.svg';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import {
    CheckBoxSelection,
    DropDownListComponent,
    Inject,
    MultiSelectComponent,
} from '@syncfusion/ej2-react-dropdowns';
import { setPreviewImage } from '../accessmgmtReducer';

export default function MappedCompanyDetails(props: any) {
    const { setAddScreen, onRefresh } = props;
    const dispatch = useDispatch();
    const [companyList, setCompanyList] = useState([]);
    const [mappedData, setMappedData] = useState<any>([]);
    const [companyErr, setCompanyErr] = useState<string>('');
    const [roleErr, setRoleErr] = useState<string>('');
    const [userGeneralInfo, setUserGenInfo] = useState<any[]>([]);

    let uploadedImageFile = useSelector(
        (state: RootState) => state.accessMgmtReducer.previewImage
    );
    const [companyMappingObj, setCompanyMappingObj] = useState<any>({
        companyId: null,
        locationId: null,
        roleId: null,
    });

    const isLLAdminUser = useSelector(
        (state: RootState) => state.sideBarReducer.isLLAdminUser
    );

    const selRowData = useSelector(
        (state: RootState) => state.gridReducer.selectedRowData
    );

    const userManagementData = useSelector(
        (state: RootState) => state.accessMgmtReducer.userAccessData
    );

    // const locationsDataList = useSelector(
    //     (state: RootState) => state.accessMgmtReducer.locatonsList
    // );
    const rolesListData = useSelector(
        (state: RootState) => state.accessMgmtReducer.rolesList
    );

    console.log(rolesListData);
    const [locationsDataList, setLocationsDataList] = useState<any[]>([]);
    const [rolesList, setRolesList] = useState<any[]>([]);

    useEffect(() => {
        fetchCompanyList();
        fetchRoleDetails();
    }, []);

    const fetchRoleDetails = () => {
        try {
            console.log(
                isLLAdminUser
                    ? rolesListData.filter(
                          (ele) =>
                              ele.roleName?.toLowerCase() ===
                              'Rl Admin'?.toLowerCase()
                      )
                    : rolesListData
            );
            setRolesList(
                isLLAdminUser
                    ? rolesListData.filter(
                          (ele) =>
                              ele.roleName?.toLowerCase() ===
                              'Rl Admin'?.toLowerCase()
                      )
                    : rolesListData
            );
        } catch (error) {}
    };

    const assignedCompanyList = useSelector(
        (state: RootState) => state.sideBarReducer.companyList
    );

    const fetchCompanyList = useCallback(async () => {
        try {
            const endPointURL = getAccessMgmtEndPoint('CompanyList');
            await axios
                .get(endPointURL)
                .then((response: any) => {
                    if (response.status === 200) {
                          response.data.forEach((element: any) => {
                            element.companyId = element.id;
                        });
                        setCompanyList(
                            isLLAdminUser
                                ? response.data.filter(
                                      (ele: any) => ele.active === true
                                  )
                                : assignedCompanyList
                        );
                    }
                })
                .catch((err) => {
                    console.log(err);
                    notify(
                        'Error! Unable to fetch data. Please try after sometime.',
                        'error'
                    );
                });
        } catch (error) {}
    }, []);

    const fetchReclaimCentersByCompany = useCallback(async (companyId: any) => {
        try {
            const endPointURL = getAccessMgmtEndPoint(
                'ReclaimCentersByCompany',
                companyId
            );
            await axios
                .get(endPointURL)
                .then((response: any) => {
                    if (response.status === 200) {
                        setLocationsDataList(
                            response.data.filter(
                                (ele: any) => ele.active === true
                            )
                        );
                    }
                })
                .catch((err) => {
                    console.log(err);
                    notify(
                        'Error! Unable to fetch data. Please try after sometime.',
                        'error'
                    );
                });
        } catch (error) {}
    }, []);

    useEffect(() => {
        setUserGenInfo([]);
        if (selRowData && selRowData.length > 0) {
            console.log(rolesList);
            setUserGenInfo(selRowData);
            const userCompanyMapping: any = [];
            const selectedRow: any = userManagementData.find(
                (ele: any) => ele.id === selRowData[0].id
            );
            selectedRow?.userCompanyMapping.forEach(
                (element: any, index: number) => {
                    const roleDetails: any = [];
                    element.roleId.forEach((data: any) => {
                        const roleObj =
                            rolesListData.find((ele) => ele.id === data) || {};
                        if (Object.keys(roleObj).length > 0) {
                            roleDetails.push(roleObj);
                        }
                    });

                    userCompanyMapping.push({
                        companyDetails: element.company || {},
                        locationDetails: element.reclaimCenter || {},
                        roleDetails: roleDetails || [],
                        rowId: index + 1,
                        companyId: element?.companyId,
                    });
                }
            );

            setMappedData(userCompanyMapping);
        }
    }, [selRowData]);

    const handleMappingDelete = useCallback(
        (option: any) => {
            try {
                setMappedData(
                    mappedData.filter((ele: any) => ele.rowId !== option.rowId)
                );
            } catch (error) {}
        },
        [mappedData]
    );

    const handleSelectChange = useCallback(
        (event: any, key: string) => {
            if (key === 'company') {
                setCompanyMappingObj({
                    ...companyMappingObj,
                    companyId: event.target.value,
                    roleId: null,
                });
                setLocationsDataList([]);
                fetchReclaimCentersByCompany(event.target.value);
            }

            if (key === 'role') {
                setCompanyMappingObj({
                    ...companyMappingObj,
                    roleId: event.target.value,
                });
            }

            if (key === 'location') {
                setCompanyMappingObj({
                    ...companyMappingObj,
                    locationId: event.target.value,
                });
            }
        },
        [companyMappingObj]
    );

    const addMapping = useCallback(() => {
        try {
            setCompanyErr('');
            setRoleErr('');
            if (companyMappingObj.companyId === null) {
                setCompanyErr('Please select Company');
                return;
            }

            if (
                companyMappingObj.roleId === null ||
                companyMappingObj?.roleId?.length === 0
            ) {
                setRoleErr('Please select Role');
                return;
            }

            const companyDetails = companyList.find(
                (ele: any) => ele.id === companyMappingObj.companyId
            );
            const locationDetails = locationsDataList.find(
                (ele: any) => ele.id === parseInt(companyMappingObj.locationId)
            );
            const roles = rolesListData.filter((ele: any) =>
                companyMappingObj?.roleId?.includes(ele.id)
            );

            const duplicateCheck = mappedData.filter(
                (ele: any) => ele.id === companyMappingObj.companyId
            );

            if (duplicateCheck.length > 0) {
                setCompanyErr('Already exists in list');
                return;
            }

            setMappedData([
                ...mappedData,
                {
                    companyDetails: companyDetails || {},
                    locationDetails: locationDetails || {},
                    roleDetails: roles || [],
                    rowId: mappedData.length + 1,
                    companyId: companyMappingObj.companyId,
                },
            ]);

            setCompanyMappingObj({
                companyId: null,
                roleId: null,
                locationId: null,
            });
        } catch (error) {}
    }, [
        companyMappingObj,
        companyList,
        rolesListData,
        locationsDataList,
        mappedData,
    ]);

    const updateUserGeneralTabApi = async (data: any) => {
        try {
            //   const token = sessionStorage.getItem('token');
            //  const token = UserService.getToken()
            const endPointURL = updateAccessReqEndPoint('Users');
            // let store = getSelectedStorebyId(userGeneralInfo[0]?.storeId);
            const userCompanyMapping: any[] = [];
            console.log(mappedData);

            mappedData.forEach((element: any) => {
                var roleIds = element?.roleDetails?.map((item: any) => {
                    return item.id;
                });

                userCompanyMapping.push({
                    companyId: element?.companyDetails?.id,
                    roleId: roleIds,
                    reclaimCenterId: element?.locationDetails?.id,
                });
            });

            // if (userGeneralInfo[0]?.userCompanyMapping?.length > 0) {
            //     userGeneralInfo[0]?.userCompanyMapping?.map((item: any) => {
            //         userCompanyMapping.push({
            //             companyId: item?.company?.id,
            //             roleId: item.roleId || [],
            //             reclaimCenterId: item?.reclaimCenter?.id,
            //         });
            //     });
            // }

            let body = {
                // userId: userGeneralInfo[0]?.company

                firstname: userGeneralInfo[0]?.firstname,
                lastname: userGeneralInfo[0]?.lastName,
                company: userGeneralInfo[0]?.company,
                jobTitle: userGeneralInfo[0]?.jobTitle,
                username: userGeneralInfo[0]?.username,
                roleId: userGeneralInfo[0]?.roleId,
                reclaimCenterId: userGeneralInfo[0]?.reclaimCenterId,
                endDate: userGeneralInfo[0]?.endDate,

                email: userGeneralInfo[0]?.email,
                phoneNumber: userGeneralInfo[0]?.phoneNumber,
                fax: userGeneralInfo[0]?.fax,
                language: userGeneralInfo[0]?.language,
                timezone:
                    userGeneralInfo[0]?.timezone !== null &&
                    userGeneralInfo[0]?.timezone !== undefined
                        ? userGeneralInfo[0]?.timezone
                        : 'en-us',
                countryId: userGeneralInfo[0]?.country,
                stateId: userGeneralInfo[0]?.stateId,
                city: userGeneralInfo[0]?.city,
                street: userGeneralInfo[0]?.street,

                password: userGeneralInfo[0]?.password,
                storeId:
                    userGeneralInfo[0]?.storeId !== null &&
                    userGeneralInfo[0]?.storeId !== undefined
                        ? userGeneralInfo[0]?.storeId
                        : userGeneralInfo[0]?.storeId,
                userType: userGeneralInfo[0]?.userType,
                userId: userGeneralInfo[0]?.userId,
                id: userGeneralInfo[0]?.id,
                status: userGeneralInfo[0]?.activeForGrid,
                userCompanyMapping: [...userCompanyMapping],
                scanUser:
                    userGeneralInfo[0]?.scanUser !== undefined &&
                    userGeneralInfo[0]?.scanUser !== null
                        ? userGeneralInfo[0]?.scanUser
                        : {},
            };

            if (
                uploadedImageFile.length > 0 &&
                uploadedImageFile !== undefined
            ) {
                Object.assign(body, { image: uploadedImageFile[0].base64 });
            } else {
                Object.assign(body, { image: userGeneralInfo[0]?.image });
            }
            if (userGeneralInfo[0]?.userType === 'External') {
                if (
                    userGeneralInfo[0]?.scanUser !== undefined &&
                    userGeneralInfo[0]?.scanUser !== null &&
                    userGeneralInfo[0]?.scanUser !== ''
                ) {
                    Object.assign(body, {
                        scanUser: {
                            binMaxScanQty:
                                userGeneralInfo[0]?.scanUser?.binMaxScanQty,
                            boxMaxScanQty:
                                userGeneralInfo[0]?.scanUser?.boxMaxScanQty,
                            scanMaxQty:
                                userGeneralInfo[0]?.scanUser?.scanMaxQty,
                            canCloseBin:
                                userGeneralInfo[0]?.scanUser?.canCloseBin,
                            hourlyScanGoal:
                                userGeneralInfo[0]?.scanUser?.hourlyScanGoal,
                            supervisorPassword:
                                userGeneralInfo[0]?.scanUser
                                    ?.supervisorPassword,
                            id: userGeneralInfo[0]?.scanUser?.id,
                        },
                    });
                } else {
                    Object.assign(body, { scanUser: {} });
                }
            }
            //  await axios.post(endPointURL, body, { headers: { 'Authorization': `Bearer ${token}` } }).then(
            await axios
                .post(endPointURL, body)
                .then(
                    // (res) => {
                    //     notify('User updated successfully', 'success');
                    //     getUsers('Users');
                    //    // clearPreview();
                    // }
                    (res: any) => {
                        if (res.data.status !== 200) {
                            notify(res.data.message, 'error');
                        } else {
                            notify(res.data.message, 'success');
                        }
                        setAddScreen(false);
                        onRefresh('Users');
                        setTimeout(() => {
                            // dispatch(setRowData(res.data[0]));
                            dispatch(setPreviewImage([]));
                        }, 10);
                        // clearPreview();
                    }
                )
                .catch((err) => {
                    setAddScreen(false);
                    console.log(err, 'Users');
                    notify('Failed to update user', 'error');
                });
        } catch (error) {}
    };

    return (
        <>
            <div className="row">
                <div className="col-sm-4 mt-3">
                    <label className="label-title">
                        Company
                        <span className="requiredStar">*</span>
                    </label>

                    <DropDownListComponent
                        value={companyMappingObj.companyId}
                        dataSource={companyList}
                        placeholder="Company Name"
                        allowFiltering={false}
                        fields={{
                            text: 'companyName',
                            value: 'id',
                        }}
                        onChange={(event: any) => {
                            setCompanyErr('');
                            handleSelectChange(event, 'company');
                        }}
                        popupHeight="200px"
                    />
                    {companyErr.length > 0 && (
                        <div style={{ color: 'red' }} className="">
                            {companyErr}
                        </div>
                    )}
                </div>

                <div className="col-sm-4 mt-3">
                    <label className="label-title">
                        Role <span className="requiredStar">*</span>
                    </label>

                    <MultiSelectComponent
                        value={companyMappingObj.roleId}
                        id="checkbox"
                        dataSource={rolesList?.filter(
                            (ele: any) => ele.status === 'Active'
                        )}
                        fields={{
                            text: 'roleName',
                            value: 'id',
                        }}
                        placeholder="Select Role"
                        mode="CheckBox"
                        onChange={(event: any) => {
                            setRoleErr('');
                            handleSelectChange(event, 'role');
                        }}
                    >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>

                    {roleErr.length > 0 && (
                        <div style={{ color: 'red' }} className="">
                            {roleErr}
                        </div>
                    )}
                </div>

                <div className="col-sm-3 mt-3">
                    <label className="label-title">Location</label>
                    <DropDownListComponent
                        value={companyMappingObj.locationId}
                        dataSource={locationsDataList?.filter(
                            (ele: any) => ele.active === true
                        )}
                        placeholder="Location"
                        allowFiltering={false}
                        fields={{
                            text: 'reclaimcenterName',
                            value: 'id',
                        }}
                        onChange={(event: any) =>
                            handleSelectChange(event, 'location')
                        }
                        popupHeight="200px"
                    />
                </div>
                <div className="col-sm-1 mt-5">
                    <ButtonComponent
                        style={{
                            opacity: '1',
                            borderRadius: '4px',
                            pointerEvents: 'all',
                            backgroundColor: '#636799',
                            color: '#ffffff',
                            cursor: 'pointer',
                        }}
                        onClick={() => addMapping()}
                    >
                        Add
                    </ButtonComponent>
                </div>
            </div>

            <div className="mt-4">
                <table className="table table-bordered">
                    <thead>
                        <tr className="m-0">
                            <th style={{ width: 150 }}>Company Name</th>
                            <th style={{ width: 300 }}>Assigned Role's</th>
                            <th style={{ width: 150 }}> Location</th>
                            <th style={{ width: 50 }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {mappedData.length === 0 && (
                            <tr>
                                <td
                                    className="user-role-empty"
                                    colSpan={4}
                                    style={{ textAlign: 'center' }}
                                    align="center"
                                >
                                    No roles assigned to company
                                </td>
                            </tr>
                        )}

                        {mappedData.map((option: any, idx: number) => (
                            <tr key={idx}>
                                <td>{option?.companyDetails?.companyName}</td>
                                <td>
                                    {option?.roleDetails &&
                                        option?.roleDetails.map(
                                            (role: any, idx: number) => (
                                                <span
                                                    className="role-tag"
                                                    key={idx}
                                                >
                                                    {role?.roleName}
                                                </span>
                                            )
                                        )}
                                </td>
                                <td>
                                    {option.locationDetails?.reclaimcenterName}
                                </td>
                                <td>
                                    <Delete
                                        onClick={() =>
                                            handleMappingDelete(option)
                                        }
                                        height={30}
                                        cursor={'pointer'}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="">
                <ButtonComponent
                    cssClass="float-right px-5 py-3"
                    style={{
                        opacity: '1',
                        borderRadius: '4px',
                        pointerEvents: 'all',
                        backgroundColor: '#636799',
                        color: '#ffffff',
                        cursor: 'pointer',
                    }}
                    disabled={mappedData?.length === 0}
                    onClick={() => updateUserGeneralTabApi(4)}
                >
                    Save
                </ButtonComponent>
            </div>
        </>
    );
}
